import { render, staticRenderFns } from "./CreateGroupsManagement.vue?vue&type=template&id=a4fa665e&scoped=true"
import script from "./CreateGroupsManagement.vue?vue&type=script&lang=js"
export * from "./CreateGroupsManagement.vue?vue&type=script&lang=js"
import style0 from "./CreateGroupsManagement.vue?vue&type=style&index=0&id=a4fa665e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fa665e",
  null
  
)

export default component.exports